import { render, staticRenderFns } from "./InactiveFacilities.vue?vue&type=template&id=3742f404&scoped=true"
import script from "./InactiveFacilities.vue?vue&type=script&lang=js"
export * from "./InactiveFacilities.vue?vue&type=script&lang=js"
import style0 from "./InactiveFacilities.vue?vue&type=style&index=0&id=3742f404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3742f404",
  null
  
)

export default component.exports